import {SetContactPersonToOfferFromDialogExecutionStep} from './set-contact-person-to-offer-from-dialog-execution-step';

export class SetContactPersonToOrderFromDialogExecutionStep extends SetContactPersonToOfferFromDialogExecutionStep {

}
